function initSlider ($reinit) {
    $('.b-contest-slider').each(function() {
        var $context = $(this),
            $slider = $('.b-contest-slider__slider', $context);

        $slider.slick({
            dots: false,
            fade: true,
            prevArrow: $('.b-contest-slider__arrow-prev'),
            nextArrow: $('.b-contest-slider__arrow-next')
        })
    });
}
$(function () {
    initSlider();
});
